import React, { useEffect, useRef, useState } from "react";
import { useQuery } from "@apollo/client";
import { GET_HCP_PORTALS } from 'queries/queries';
import arrowIcon from '../../assets/images/arrow_left_icon.png';
import { useHistory } from "react-router-dom";
import backArrow from '../../assets/images/left_arrow.png';

const HcpPortals = () => {
  const { loading, error, data } = useQuery(GET_HCP_PORTALS, {
    fetchPolicy: "no-cache",
  });

  const portals = data?.getHcpPortals || [];
  const history = useHistory();
  const viewportRef = useRef(null);
  const [page, setPage] = useState(0);
  const total = portals.length || 1;

  useEffect(() => {
    const wrapper = document.querySelector(".scrollable");
    if (!wrapper) return;
  
    document.querySelector(".scrollable").addEventListener(
      "touchmove",
      function(event) {
        event.stopPropagation();
      },
      false
    );
  });

  // update page on scroll
  useEffect(() => {
    const el = viewportRef.current;
    if (!el) return;

    const onScroll = () => {
      const idx = Math.round(el.scrollLeft / el.clientWidth);
      setPage(Math.max(0, Math.min(idx, total - 1)));
    };

    el.addEventListener("scroll", onScroll, { passive: true });
    return () => el.removeEventListener("scroll", onScroll);
  }, [total]);


  if (loading) return <p>Loading...</p>;
  if (error) return <p>Error loading portals.</p>;

  const handleRedirect = (url) => {
    if (url) {
      window.open(url, "_blank");
    }
  };

  const handleBack = () => {
    history.goBack() 
  };

  return (
    <div className="hcp-portals scrollable">
      <div className="points-header">
        <img 
          src={backArrow} 
          alt="back" 
          className="points-header-arrow" 
          onClick={handleBack} 
        />
        <div className="points-header-title">HCP-Portale</div>
        <div className='points-header-empty'></div>
      </div>

      <div className="portals-slider" ref={viewportRef}>
        {portals.map((p, i) => (
          <div className="slider-icon" key={i} onClick={() => handleRedirect(p.link)}>
            <img src={p.imageUrl} alt={p.name} />
          </div>
        ))}
      </div>

      <div className="portals-list">
        {portals.map((p, i) => (
          <div className="portal-card" key={i} onClick={() => handleRedirect(p.link)}>
            <img src={p.imageUrl} alt={p.name} className="logo" />
            <div className="content">
              <h3>{p.name}</h3>
              <p>{p.description}</p>
            </div>
            <div className="arrow">
              <img src={arrowIcon} alt="arrow" />
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default HcpPortals;